import { useState, useEffect } from 'react';
import { EventBusProps, eventBusInstance, EventKeys } from '@moodys/cre-cpm.models.events';
import { UseEventPublishedOptions, useEventPublisher } from '@moodys/cre-cpm.hooks.use-event-publisher';

export interface UseEventSubscriberOptions extends UseEventPublishedOptions {
  key: EventKeys,
  eventBus?: EventBusProps
}

export const useEventSubscriber = <T>(
  {
    key,
    maxRetries = 10,
    retryEvery = 500,
    minSubscribers = 0,
    eventBus = eventBusInstance,
  }: UseEventSubscriberOptions,
  initialState?: T | undefined,
): [ T | undefined, (value: T | undefined) => void] => {
  const [value, setValue] = useState<T | undefined>(initialState);
  const [publish] = useEventPublisher<T | undefined>({
    key,
    maxRetries,
    retryEvery,
    minSubscribers,
    eventBus,
  });
  const listener = (_key: EventKeys, data?: T) => {
    setValue(data);
  };
  useEffect(() => {
    eventBus.subscribe<T>(key, listener);
    return () => {
      eventBus.unsubscribe(listener);
    }
  }, []);

  const publishValue = (valueToPublish: T | undefined) => publish(valueToPublish);

  return [value, publishValue];
};
